import { storage } from '../firebase';

const getUrlImage = (name) =>
  new Promise((resolve, reject) => {
    storage
      .ref(`images/${name}`)
      .getDownloadURL()
      .then((url) => resolve(url))
      .catch(() => reject('Ocurrió un error.'));
  });

const getUrlAudio = (name) =>
  new Promise((resolve, reject) => {
    storage
      .ref(`audios/${name}`)
      .getDownloadURL()
      .then((url) => resolve(url))
      .catch(() => reject('Ocurrió un error.'));
  });

export default {
  getUrlImage,
  getUrlAudio,
};
